export default __webpack_public_path__ + "static/homepage-banner-9c251a4e71305fd0a40c897ae158c3e9.jpg";